import { getApiClient, initializeApiClient } from "../apiService";
export const GetRecommendationEvaluationData = async (subTaskFlowGUID) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post("api/RecommendationEvaluation/GetRecommendationEvaluation", {
    subTaskFlowGUID: subTaskFlowGUID,
  });

  return response;
};
